// extracted by mini-css-extract-plugin
export default {"faqs":"vE-z","faqContent":"wE-z","faq":"xE-z"};